import { Modal, Button } from "../../../ui/index.ts";
import type { AllocationPeriodUi } from "../../../../types/time-allocation.ts";
import { periodDisplayName } from "../../../../utils/allocation-period-label.ts";

import styles from "./period-change-confirm-modal.module.css";

export type PeriodChangeConfirmModalProps = {
  open: boolean;
  nextPeriod: AllocationPeriodUi | null;
  /** When true, some members already have a project allocation (not GLOBAL). */
  hasExistingAllocations: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function PeriodChangeConfirmModal({
  open,
  nextPeriod,
  hasExistingAllocations,
  onConfirm,
  onCancel,
}: PeriodChangeConfirmModalProps) {
  const toRaw = nextPeriod != null ? periodDisplayName(nextPeriod) : "new";
  const to = toRaw.charAt(0).toUpperCase() + toRaw.slice(1);

  const title = hasExistingAllocations
    ? "Change allocation period?"
    : "Confirm allocation period";

  const body = hasExistingAllocations ? (
    <p className={`body-sm ${styles.copy}`}>
      Previously allotted members will be reset to 0 and will be inactive
      unless you reassign them. Allocation will be on a {to} basis.
    </p>
  ) : (
    <p className={`body-sm ${styles.copy}`}>Allocation will be on a {to} basis.</p>
  );

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      footer={
        <div className={styles.footerActions}>
          <Button type="button" variant="muted-outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      }
    >
      {body}
    </Modal>
  );
}
